module.exports = __webpack_public_path__ + "static/img/image4.bb18f3a3.png";